import { takeLatest, call, put } from "redux-saga/effects";
import { db } from "helpers/firebase/firebaseConfig";
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  updateDoc,
} from "firebase/firestore";
import {
  fetchCancellationsSuccess,
  fetchCancellationsFailure,
  createCancellationInvoiceSuccess,
  createCancellationInvoiceFailure,
  updateCancellationStatusSuccess,
  updateCancellationStatusFailure,
  fetchCancellationStatisticsSuccess,
  fetchCancellationStatisticsFailure,
} from "./actions";
import {
  FETCH_CANCELLATIONS_REQUEST,
  CREATE_CANCELLATION_INVOICE_REQUEST,
  UPDATE_CANCELLATION_STATUS_REQUEST,
  FETCH_CANCELLATION_STATISTICS_REQUEST,
} from "./actionTypes";
import {
  createCancellationInvoice,
  getCancellationHistory,
  getCancellationStatistics,
} from "helpers/api/cancellationHelper";
import { toast } from "react-toastify";

// Fetch cancellations for a provider
function* handleFetchCancellations({ payload }) {
  try {
    const cancellations = yield call(getCancellationHistory, payload);
    yield put(fetchCancellationsSuccess(cancellations));
  } catch (error) {
    console.error("Error fetching cancellations:", error);
    yield put(fetchCancellationsFailure(error.message));
    toast.error("Failed to load cancellation history");
  }
}

// Create cancellation invoice
function* handleCreateCancellationInvoice({ payload }) {
  try {
    const result = yield call(
      createCancellationInvoice,
      payload.orderData,
      payload.serviceProviderId,
      payload.reason
    );

    if (result.success) {
      yield put(createCancellationInvoiceSuccess(result.cancellationTrackData));
      toast.success(result.message);
    } else {
      yield put(createCancellationInvoiceFailure(result.error));
      toast.error(result.message);
    }
  } catch (error) {
    console.error("Error creating cancellation invoice:", error);
    yield put(createCancellationInvoiceFailure(error.message));
    toast.error("Failed to create cancellation invoice");
  }
}

// Update cancellation status
function* handleUpdateCancellationStatus({ payload }) {
  try {
    const cancellationRef = doc(db, "cancellation_track", payload.cancellationId);
    
    yield call(updateDoc, cancellationRef, {
      status: payload.newStatus,
      updated_at: new Date().toISOString(),
    });

    // Fetch updated document
    const updatedDoc = yield call(getDoc, cancellationRef);
    
    yield put(
      updateCancellationStatusSuccess({
        id: payload.cancellationId,
        ...updatedDoc.data(),
      })
    );
    
    toast.success("Cancellation status updated successfully");
  } catch (error) {
    console.error("Error updating cancellation status:", error);
    yield put(updateCancellationStatusFailure(error.message));
    toast.error("Failed to update cancellation status");
  }
}

// Fetch cancellation statistics
function* handleFetchCancellationStatistics({ payload }) {
  try {
    const stats = yield call(getCancellationStatistics, payload);
    yield put(fetchCancellationStatisticsSuccess(stats));
  } catch (error) {
    console.error("Error fetching cancellation statistics:", error);
    yield put(fetchCancellationStatisticsFailure(error.message));
    toast.error("Failed to load cancellation statistics");
  }
}

export function* watchCancellationsSaga() {
  yield takeLatest(FETCH_CANCELLATIONS_REQUEST, handleFetchCancellations);
  yield takeLatest(CREATE_CANCELLATION_INVOICE_REQUEST, handleCreateCancellationInvoice);
  yield takeLatest(UPDATE_CANCELLATION_STATUS_REQUEST, handleUpdateCancellationStatus);
  yield takeLatest(FETCH_CANCELLATION_STATISTICS_REQUEST, handleFetchCancellationStatistics);
}
